{
    "SSO_Login_Title": "Einmalige Anmeldung (SSO)",
    "SSO_Login_Description": "Bitte warten Sie, die Benutzerdaten werden überprüft. Dies sollte nicht lange dauern.",
    "SSO_Login_Error": "Es tut uns leid, wir können Sie nicht ausfindig machen. Bitte versuchen Sie es erneut. Wenn dieses Problem weiterhin besteht, wenden Sie sich bitte an Ihren Anwendungsadministrator.",
    "SSO_MissingCode_Error": "Entschuldigung, da ist etwas schief gelaufen. Bitte versuchen Sie es erneut. Wenn dieses Problem weiterhin besteht, wenden Sie sich bitte an Ihren Anwendungsadministrator.",
    "NAME": "SSOLanguage"
}